<template>
    <div class="n-ptb-4">
        <Breadcrumb :data="breadcrumb"></Breadcrumb>

        <div class="n-ptb-4 c-max-width n-m-auto n-mt-3">
            <div class="n-flex n-bg-1 n-p-4"
                 v-if="loadings">
                <div class="list-thumb  n-flex-s n-mr-3 n-skeleton"></div>
                <div class="n-flex-g n-flex-g-w-1-hack">
                    <div class="n-skeleton n-skeleton-text n-ptb-6"></div>
                    <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-6"></div>
                    <div class="n-skeleton n-skeleton-text n-mt-6"></div>
                </div>
            </div>

            <div class="n-flex n-flex-a-s book-top"
                 v-else>
                <div class="n-flex n-col-1 book-info">
                    <div class="list-thumb n-flex-s n-mr-3">
                        <NImage class="list-thumb-image n-col-1 n-h-1"
                                type="cover"
                                zoomView
                                :src="data.coverPicture">
                        </NImage>
                    </div>
                    <div class="n-flex-g n-flex-g-w-1-hack book-info">
                        <h1 class="n-c-4 n-m-0"
                            style="color:#00008b"
                            v-if="(data.seriesInfo||[]).length>0"><span class="n-mr-3 n-inline"><i>{{ data.seriesInfo[0].tagName || '' }}</i></span></h1>
                        <h1 class="n-c-4 n-m-0"
                            style="color:#00008b"
                            v-if="(data.seriesInfo||[]).length>0 &&(data.seriesInfo[0].tagVolume||'')!=''"><span class="n-mr-3 n-inline">{{ 'Volume '+data.seriesInfo[0].tagVolume || '' }}</span></h1>
                        <h1 class="n-f-bold n-c-4 n-m-0 b-detail-title"><span class="n-mr-3 n-inline">{{ data.title || '-' }}</span></h1>
                        <!-- <div class="n-flex n-c-4 n-mt-1">
                            <h4 class="n-mb-0 n-flex-s">{{ bookRelatedPersonLabel }}:&nbsp;&nbsp;</h4>
                            <ul class="n-ul n-p-0 n-m-0 n-flex n-flex-w">
                                <li v-for="item, index in data.bookRelatedPerson"
                                    :key="item.name">{{ item.name +
                 ((item.title || '') == '' ? '' : (`(${item.title})`)) }}{{ index <
                 data.bookRelatedPerson.length - 1 ? '、' : '' }}</li>
                            </ul>
                        </div> -->
                        <!-- <h4 class="n-c-4 n-mb-0 n-mt-3 n-f-normal"
                            v-if="publication && publication.publishDate && data.bookPublishType != 'print'">
                            <label class="n-flex-s">{{ LAN.common.publishDate }}:&nbsp;&nbsp;</label>{{ publication ?
                 parseCDate(publication.publishDate) : '-' }}
                        </h4> -->

                        <!-- <span class="n-block n-c-4"
                              v-if="data.publisher">
                            <label class="n-flex-s">{{ LAN.common.publisher }}:&nbsp;&nbsp;</label>{{ data.publisher || '-'
                             }}
                        </span>
                        <span class="n-block n-c-4"
                              v-if="publication && publication.isbn13">
                            <label class="n-flex-s">{{ 'ISBN (' + (data.bookPublishType == 'EBook' ? 'Online Only' : (
                 data.bookPublishType == 'print' ? 'Print Only' : "Print & Online"
             )) + ')' }}:&nbsp;&nbsp;</label>{{ publication.isbn13 }}
                        </span>

                        <span class="n-block n-c-4"
                              v-if="publication && publication.mediumDesc">
                            <label class="n-flex-s">{{ LAN.book.medium }}:&nbsp;&nbsp;</label>{{ (data.bookPublishType ==
                 'EBook' ? 'Online Only' : (
                 data.bookPublishType == 'print' ? 'Print Only' : "Print & Online"
             )) }}
                        </span> -->
                        <!-- <span class="n-block n-c-4"
                              v-if="data.pages">
                            <label class="n-flex-s">{{ LAN.common.pages }}:&nbsp;&nbsp;</label>{{ data.pages }}
                        </span>

                        <span class="n-block n-c-4"
                              v-if="publication && publication.size">
                            <label class="n-flex-s">{{ LAN.book.size }}:&nbsp;&nbsp;</label>{{ publication.size }}
                        </span> -->

                        <!-- <span class="n-block n-c-4 n-mb-2" v-if="publication && publication.publishStatusDesc">
                             <label class="n-flex-s">{{ LAN.book.status
                                 }}:&nbsp;&nbsp;</label>{{ publication.publishStatusDesc }}
                         </span> -->

                        <div class="n-flex n-flex-a-c n-mt-3">
                            <a-button type="primary"
                                      class="c-tab-link c-tab-link-event n-mr-3"
                                      v-if="auth && CONTENT && checkAuthEnd"
                                      @click="openPDF">{{ LAN.common.PDFAll }}</a-button>
                            <a-button type="primary"
                                      class="c-tab-link c-tab-link-event n-mr-3"
                                      v-if="!auth && CONTENT && checkAuthEnd"
                                      @click="goContact">{{
                      LAN.common.subscribe }}</a-button>

                            <router-link v-if="(data.seriesInfo||[]).length>0 
                                       && (data.seriesInfo[0].periodicalId||'')!=''
                                       && (data.seriesInfo[0].volumeId||'')!=''
                                       && (data.seriesInfo[0].issueId||'')!=''"
                                         :to="{ name: 'journalPanel', query: { jid: data.seriesInfo[0].periodicalId, sid: data.seriesInfo[0].volumeId,iid: data.seriesInfo[0].issueId} }"
                                         class="c-tab-link c-tab-link-event">
                                Read the full text online...
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="n-flex-s n-ml-4 book-pub-list n-plr-3 n-bg-1 n-radius-10"
                     v-if="data.publication?.filter(item => !!item.listPrice && item.listPrice > 0 && (item.publishStatusCode||'') != 'OUT_OF_PRINT').length > 0">
                    <h2 class="n-f-bold n-line-height-1 n-ptb-3 n-m-0">{{ LAN.book.accessBook }}</h2>

                    <ul class="n-ul n-m-0 n-p-0">
                        <li v-for="(item,index) in data.publication.filter(item => !!item.listPrice && item.listPrice > 0 && (item.publishStatusCode||'') != 'OUT_OF_PRINT')"
                            class="n-t-line n-flex n-flex-a-c n-ptb-3 n-flex-j-sb"
                            :key="index">
                            <div>
                                <h4 class="n-c-base n-line-height-1 n-mb-0">{{ item.mediumCode.toLowerCase() == 'print' ? (item.bindingDesc  || item.mediumDesc): item.mediumDesc }}</h4>
                                <span class="n-line-height-1">{{ item.currency }} {{ formatNumber(item.listPrice, 2) }}</span>
                            </div>

                            <!-- v-if="userInfo?.type && userInfo?.type == 'personal' || true" -->

                            <!-- <a-tooltip placement="topRight"
                                       :trigger="['hover', 'click']"
                                       :overlayStyle="{ width: 'auto', maxWidth: 'none' }"
                                       v-else>
                                <template #title>
                                    <div class="n-flex n-flex-a-c">
                                        <span class="n-flex-s n-mr-2">{{ LAN.book.goLogin }}</span>
                                        <a href="javascript:;"
                                           class="c-link-blue c-tab-link c-tab-link-event n-flex-s"
                                           @click="$emit('personallogin')">{{ LAN.book.goLoginText }}</a>
                                    </div>
                                </template>
                                <button class="n-c-1 n-bg-base n-ml-3 n-plr-4 c-tab-link c-tab-link-event c-hover-3 n-pointer buy-button"
                                        :disabled="true">{{ LAN.common.buy }}</button>
                            </a-tooltip> -->
                            <div v-if="item.mediumCode == 'EBook' && checkAuthEnd  && CONTENT">
                                <button class="n-c-1 n-bg-base n-ml-3 n-plr-4 c-tab-link c-tab-link-event c-hover-3 n-pointer buy-button"
                                        v-if="isInCart(item)"
                                        :disabled="true">{{ LAN.cart.isInCart }}</button>

                                <button class="n-c-1 n-bg-base n-ml-3 n-plr-4 c-tab-link c-tab-link-event c-hover-3 n-pointer buy-button"
                                        v-else-if="auth && userInfo?.type && userInfo?.type == 'personal'"
                                        :disabled="true">{{ LAN.common.had }}</button>

                                <button class="n-c-1 n-bg-base n-ml-3 n-plr-4 c-tab-link c-tab-link-event c-hover-3 n-pointer buy-button"
                                        v-else
                                        @click="toBuy(item)">{{ LAN.common.buy }}</button>
                            </div>

                            <a href="javascript:;"
                               class="c-tab-link c-tab-link-event n-flex-s n-ml-3  c-hover-3 n-pointer n-radius-3"
                               v-else-if="(item.amazonLink || '')!=''">
                                <img style="height: 30px;"
                                     class="n-block"
                                     @click="gotoAmazonBookPage(item.amazonLink)"
                                     src="/images/buy_from_amazon_button.gif" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="n-bg-1">
            <div class="c-max-width n-m-auto n-bg-1 n-mt-4 n-ptb-4 n-flex detail-body"
                 v-if="!loadings">
                <div v-if="newsDetailId"
                     class="n-flex-g"
                     :style="{'marginRight': '80px', 'marginTop': '60px'}">
                    <NewsDetailContent :id="newsDetailId"
                                       pageInner></NewsDetailContent>
                </div>

                <div class="n-flex-g n-flex-g-w-1-hack book-detail"
                     id="book-detail"
                     v-else
                     :style="{marginRight: '80px', paddingBottom: hackBottom + 'px'}">
                    <div class="book-sections n-b-line n-pt-6 n-pb-3"
                         id="overview"
                         v-if="(data.childSet && data.childSet.length > 0) || (data.parentSet && data.parentSet.id) || (data.seriesInfo && data.seriesInfo.length > 0) || (data.bookRelatedPerson && data.bookRelatedPerson.length > 0)">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.common.overview }}</h4>

                        <div class="n-flex c-max-width n-m-auto"
                             v-if="data.seriesInfo && data.seriesInfo.length > 0">
                            <label class="n-flex-s">{{ LAN.book.belong.split('|SS|')[0] }}</label>

                            <ul class="n-ul n-p-0 n-m-0 n-mlr-2">
                                <li v-for="(item, index) in data.seriesInfo"
                                    class="n-c-base n-pointer c-hover-1 n-inline"
                                    :key="item.tagId"
                                    :class="{ 'n-mr-2': index != data.seriesInfo.length - 1 }">
                                    <router-link :to="{ name: 'bookSuccessionList', query: { from: 'bookDetail', id: item.tagId } }"
                                                 class="c-tab-link c-tab-link-event">
                                        {{ item.tagName }}{{ index == data.seriesInfo.length - 1 ? '' : '、' }}
                                    </router-link>
                                </li>
                            </ul>

                            <label class="n-flex-s">{{ LAN.book.belong.split('|SS|')[1] }}</label>
                        </div>

                        <div v-if="data.childSet && data.childSet.length > 0"
                             class="n-mt-2">
                            <h4 class="n-c-4 n-m-0">{{ LAN.common.childNotice }}</h4>

                            <ul class="n-ul n-plr-0 n-b-line n-pb-2">
                                <li v-for="item in data.childSet"
                                    :key="item.id">
                                    <router-link :to="{ name: 'BDetail', query: { from: $route.query.from, id: item.id, k: new Date().getTime() } }"
                                                 custom
                                                 v-slot="{ href }">
                                        <LinkOutlined class="n-c-red n-mr-1" /><a :href="href"
                                           class="n-c-base c-tab-link c-tab-link-event">{{
                           item.title }}</a>
                                    </router-link>
                                </li>
                            </ul>
                        </div>

                        <div v-if="data.parentSet && data.parentSet.id"
                             class="n-mt-2">
                            <h4 class="n-c-4 n-m-0">{{ LAN.common.parentNotice }}</h4>

                            <ul class="n-ul n-plr-0 n-b-line n-pb-2">
                                <li>
                                    <router-link :to="{ name: 'BDetail', query: { from: $route.query.from, id: data.parentSet.id, k: new Date().getTime() } }"
                                                 custom
                                                 v-slot="{ href }">
                                        <LinkOutlined class="n-c-red n-mr-1" /><a :href="href"
                                           class="n-c-base c-tab-link c-tab-link-event">{{
                           data.parentSet.title
                       }}</a>
                                    </router-link>
                                </li>
                            </ul>
                        </div>

                        <div v-if="Object.keys(bookRelatedPersonGroup).length > 0">
                            <div v-for="(item,index) in bookRelatedPersonGroup"
                                 :key="index">
                                <h4 class="n-f-4 n-f-bold n-line-height-1 n-mt-3">{{ LAN.common.authorEditor[index] + (item.length > 1 ? 's' : '') }}</h4>

                                <ul class="n-ul n-p-0 n-m-0">
                                    <li v-for="(sItem, sIndex) in item"
                                        :key="sIndex">
                                        {{ sItem.name + ((sItem.title || '') == '' ? '' : (` (${sItem.title})`)) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="book-sections n-b-line n-pt-6 n-pb-1"
                         id="description"
                         v-if="data?.description">
                        <div class="n-flex n-flex-a-c n-flex-j-sb">
                            <h4 class="n-f-6 n-f-bold">{{ LAN.common.introduce }}</h4>

                            <div class="n-flex n-pl-3 n-ptb-2">
                                <a-button type="primary"
                                          size="small"
                                          v-if="PREVIEW"
                                          @click="showViewpPreview = true">{{
                       LAN.common.PDFPreview }}</a-button>

                                <a-button type="primary"
                                          class="n-ml-2"
                                          size="small"
                                          v-if="TOC"
                                          @click="showViewTOC = true">{{
                       LAN.common.PDFTable }}</a-button>
                            </div>
                        </div>
                        <p v-html="data.description"></p>
                    </div>

                    <div class="book-sections n-b-line n-pt-6 n-pb-1"
                         id="author"
                         v-if="data?.aboutAuthor">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.book.aboutAuthor }}</h4>
                        <p v-html="data?.aboutAuthor"></p>
                    </div>

                    <div class="book-sections n-b-line n-pt-6"
                         id="contents"
                         v-if="data.chapters?.length > 0 && data.publication?.filter(item => item.mediumCode == 'EBook').length > 0">
                        <BookTable :data="data.chapters"
                                   :bid="$route.query.id"
                                   :contentPdfViewType="data.contentPdfViewType" />
                    </div>

                    <div class="book-sections n-b-line n-pt-6 n-pb-2"
                         id="msc"
                         v-if="data.mscTagInfo?.length > 0">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.book.MSC2020 }}</h4>

                        <div class="n-c-4">
                            <template v-for="(item) in (data.mscTagInfo || [])"
                                      v-bind:key="item.tagName">
                                <span class="n-block n-flex-s">{{ item.tagName }} </span>
                            </template>
                        </div>
                    </div>

                    <div class="book-sections n-pt-6"
                         id="contentNotes"
                         v-if="data.contentNotes?.length > 0">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.book.notes }}</h4>
                        <div class="n-bg-2 n-p-2">
                            <div v-for="item in data.contentNotes"
                                 v-bind:key="item">
                                <b>{{ item.noteType }}</b>
                                <p v-for="item2 in item.value"
                                   class="n-m-0"
                                   v-html="(item2.fContent || '').replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>')"
                                   v-bind:key="item2">
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="book-sections n-b-line n-pt-6 n-pb-1"
                         id="supplement"
                         v-if="data.supplement?.length > 0">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.book.supplement }}</h4>
                        <div class="n-block n-c-4">
                            <template v-for="(item, index) in data.supplement"
                                      :key="index">
                                <span class="n-flex-s n-block">
                                    <a href="javascript:;"
                                       class="c-tab-link c-tab-link-event"
                                       @click="openPreviewSub(item)">{{ item.fileName }} </a>
                                </span>
                            </template>
                        </div>
                    </div>

                    <div class="book-sections n-pt-6 n-pb-1"
                         id="publication"
                         v-if="data.publication?.length > 0">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.book.pubInfo }}</h4>
                        <div class="n-block n-c-4 n-bg-2 n-p-3">
                            <ul class="n-ul n-p-0">
                                <li class="n-flex n-flex-a-c">
                                    <h4 style="width: 100px;"
                                        class="n-flex-s n-f-bold n-m-0 n-mr-2">{{ LAN.common.publisher }}</h4><span>{{ data.publisher }}</span>
                                </li>
                                <li class="n-flex n-flex-a-c">
                                    <h4 style="width: 100px;"
                                        class="n-flex-s n-f-bold n-m-0 n-mr-2">{{ LAN.common.pages }}</h4><span>{{ data.pages }}</span>
                                </li>
                            </ul>
                            <a-table :columns="pubTable"
                                     :data-source="pubTableData"
                                     :pagination="false"
                                     :scroll="{x: true}"
                                     class="pub-table"></a-table>
                        </div>
                    </div>

                    <div class="book-sections n-pt-6 n-pb-1"
                         id="news"
                         v-if="CMSList?.length > 0">
                        <h4 class="n-f-6 n-f-bold">{{ LAN.journal.more }}</h4>
                        <ul class="n-ul n-p-0 news-list">
                            <li class="n-bg-1 n-radius-6 c-shadow n-pointer n-mb-4"
                                v-for="item in CMSList"
                                :key="item.id">
                                <a href="javascript:;"
                                   @click="changeNewsDetail(item.id)"
                                   class="n-flex n-ptb-4 c-tab-link c-tab-link-event n-col-1">
                                    <div class="n-plr-6 n-border-box n-flex-g n-flex-g-w-1-hack n-flex n-flex-dr-c n-flex-a-s n-flex-j-c n-col-1">
                                        <h4 class="n-f-6 n-c-4 n-f-bold n-m-0 n-col-1"
                                            v-html="item.title"></h4>
                                        <h4 class="n-c-4 n-e-2 n-m-0 n-mt-3 n-col-1"
                                            v-if="item.fAbstract"
                                            v-html="item.fAbstract"></h4>
                                    </div>

                                    <div class="news-list-right n-flex-s">
                                        <h4 class="n-c-4 n-text-center n-m-0">{{ LAN.news.publishDate }}</h4>
                                        <h5 class="n-c-4 n-f-bold n-text-center n-m-0">{{item.publishDate}}</h5>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <span class="n-f-2 n-c-2 n-pt-6 n-block">{{ LAN.common.updateTime }}: {{ data.updateTimeGmt }} ({{
                       formatDateToLocalTime(data.updateTimeGmt) }})
                    </span>
                </div>

                <div class="book-menu n-flex-s n-pt-6"
                     id="book-menu">
                    <ul class="n-ul n-p-0 n-m-0 book-menu-list n-ptb-4"
                        id="book-menu-list">
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 overview"
                            @click="scrollTo('overview')"
                            v-if="data.childSet && data.childSet.length > 0 || data.parentSet && data.parentSet.id || (data.seriesInfo && data.seriesInfo.length > 0) || (data.bookRelatedPerson && data.bookRelatedPerson.length > 0)">{{ LAN.common.overview }}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 description"
                            @click="scrollTo('description')"
                            v-if="data?.description">{{ LAN.common.introduce }}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 author"
                            @click="scrollTo('author')"
                            v-if="data?.aboutAuthor">{{ LAN.book.aboutAuthor }}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 contents"
                            @click="scrollTo('contents')"
                            v-if="data.chapters?.length > 0 && data.publication?.filter(item => item.mediumCode == 'EBook').length > 0">{{ LAN.common.tables }}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 msc"
                            @click="scrollTo('msc')"
                            v-if="data.mscTagInfo?.length > 0">{{ LAN.book.MSC2020 }}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 contentNotes"
                            @click="scrollTo('contentNotes')"
                            v-if="data.contentNotes?.length > 0">{{ LAN.book.notes}}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 supplement"
                            @click="scrollTo('supplement')"
                            v-if="data.supplement?.length > 0">{{ LAN.book.supplement}}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 publication"
                            @click="scrollTo('publication')"
                            v-if="data.publication?.length > 0">{{ LAN.book.pubInfo}}</li>
                        <li class="n-ptb-1 n-pointer c-hover c-link n-f-7 news"
                            @click="scrollTo('news')"
                            v-if="CMSList?.length > 0">{{ LAN.journal.more}}</li>

                        <li class="n-ptb-1"
                            v-if="newsDetailId">
                            <ul class="n-ul n-p-0 n-pl-5">
                                <li v-for="item in CMSList"
                                    :key="item.id"
                                    class="c-link n-mb-4 n-f-6 n-line-height-1-5 n-pointer c-hover">
                                    <a href="javascript:;"
                                       class="c-tab-link c-tab-link-event n-flex n-flex-a-c"
                                       :class="item.id == this.newsDetailId ? 'n-c-base' : 'n-c-4'"
                                       @click="changeNewsDetail(item.id)">
                                        <span v-html="item.title"
                                              class="c-link n-e-2 n-mr-1"></span>
                                        <ArrowRightOutlined class="link-arrow" />
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <a-modal v-model:visible="showViewCONTENT"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="CONTENT && auth && showViewCONTENT"
                 :bodyStyle="{padding: 0}"
                 :title="(CONTENT.originalName||'')"
                 :footer="null"
                 @ok="showViewCONTENT = false">
            <DocViewNoOp v-if="data.isPdfReadOnly === 1"
                         :url="CONTENT.resourceUrl"
                         :name="CONTENT.originalName"
                         class="pdf">
            </DocViewNoOp>
            <DocView v-if="data.isPdfReadOnly !== 1"
                     :url="CONTENT.resourceUrl"
                     :name="CONTENT.originalName"
                     class="pdf">
            </DocView>
        </a-modal>

        <a-modal v-model:visible="showViewTOC"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="TOC && showViewTOC"
                 :bodyStyle="{padding: 0}"
                 :title="TOC.originalName"
                 :footer="null"
                 @ok="showViewTOC = false">
            <DocView :url="TOC.resourceUrl"
                     :name="TOC.originalName"
                     class="pdf"></DocView>
        </a-modal>

        <a-modal v-model:visible="showViewpPreview"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="PREVIEW && showViewpPreview"
                 :bodyStyle="{padding: 0}"
                 :title="PREVIEW.originalName"
                 :footer="null"
                 @ok="showViewpPreview = false">
            <DocView :url="PREVIEW.resourceUrl"
                     :name="PREVIEW.originalName"
                     class="pdf"></DocView>
        </a-modal>

        <a-modal v-model:visible="previewSubData.show"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="previewSubData.show"
                 :bodyStyle="{padding: 0}"
                 :title="previewSubData.originalName"
                 :footer="null"
                 @ok="previewSubData.show = false">
            <DocView :url="previewSubData.resourceUrl"
                     :name="previewSubData.originalName"
                     class="pdf"></DocView>
        </a-modal>
    </div>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import { getStore } from '@/assets/script/store';
    import { Modal } from 'ant-design-vue'
    import NImage from '@/components/nui/NImage/NImage.vue'
    import DocView from '@/components/nui/DocView/DocView.vue'
    import DocViewNoOp from '@/components/nui/DocView/DocViewNoOp.vue'
    import BookTable from '@/components/BookTable.vue'
    import NEditorParser from '@/components/NEditorParser.vue';
    import Breadcrumb from '@/components/Breadcrumb.vue'
    import { LinkOutlined, ArrowRightOutlined } from '@ant-design/icons-vue';
    import crypto from '@/assets/script/crypto';
    import nui from '@/assets/script';
    import NewsDetailContent from '@/components/NewsDetailContent.vue'
    import indexedDBManager from '@/assets/script/indexedDB';

    export default {
        name: 'BDetail',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['scrollInfo', 'cartList'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                userInfo: {},

                checkAuthEnd: false,
                auth: false,

                showViewTOC: false,
                showViewCONTENT: false,
                showViewpPreview: false,

                previewSubData: { show: false },

                pubTable: [],
                pubTableData: [],

                loadings: false,
                loadingCMS: false,
                data: {},

                TOC: null,
                CONTENT: null,
                PREVIEW: null,
                publication: {},
                bookRelatedPersonGroup: {},

                hackBottom: 0,




                newsDetailId: null,
                CMSList: []
            })
        },
        watch: {
            scrollInfo () {
                try {
                    if (this.$route.name != 'BDetail') {
                        return
                    }
                    const bookMenu = document.getElementById('book-menu')
                    const bookMenuList = document.getElementById('book-menu-list')
                    const rect = bookMenu.getBoundingClientRect();
                    const headerHeight = document.getElementById('header').offsetHeight;
                    const distance = rect.top;

                    if (distance <= headerHeight - 30) {
                        bookMenuList.style.position = 'fixed'
                        bookMenuList.style.top = headerHeight + 'px'
                    } else {
                        bookMenuList.style.position = 'static'
                    }

                    const sections = document.querySelectorAll('.book-sections');

                    sections.forEach((section, index) => {
                        const id = section.getAttribute('id');

                        if (!id) {
                            return
                        }

                        const sTop = section.getBoundingClientRect().top - headerHeight,
                            shTop = sTop + section.offsetHeight;

                        if (((sTop >= 0 && sTop <= 100) || (sTop <= 0 && shTop > 100)) && !this.newsDetailId) {
                            document.querySelector('.book-menu-list .' + section.id).classList.add('n-active');
                        } else {
                            document.querySelector('.book-menu-list .' + section.id).classList.remove('n-active');
                        }
                    });
                } catch (err) {
                }
            }
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NActivated () {
                if (this.$route.query.newsDetailId) {
                    this.newsDetailId = this.$route.query.newsDetailId
                }

                this.checkContentPermission()

                this.userInfo = getStore({ name: 'userInfo' }) || { type: '' };
            },
            NMounted () {
                if (this.$route.query.newsDetailId) {
                    this.newsDetailId = this.$route.query.newsDetailId
                }

                this.pubTable = [{
                    title: this.LAN.common.publishDate,
                    dataIndex: 'publishDate',
                    key: 'publishDate',
                }, {
                    title: 'ISBN-13',
                    dataIndex: 'ISBN13',
                    key: 'ISBN13',
                },
                {
                    title: this.LAN.book.medium,
                    dataIndex: 'medium',
                    key: 'medium',
                }, {
                    title: this.LAN.book.binding,
                    dataIndex: 'binding',
                    key: 'binding',
                }, {
                    title: this.LAN.book.size1,
                    dataIndex: 'size',
                    key: 'size',
                }, {
                    title: this.LAN.book.pubStatus,
                    dataIndex: 'publishStatus',
                    key: 'publishStatus',
                }]
                this.loadData()
            },
            checkContentPermission () {
                this.auth = false;

                this.request(this.API.checkContentPermission, {
                    params: { dataid: this.$route.query.id, datatype: "book" }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.auth = res.data.hasAuth;
                    }

                    this.checkAuthEnd = true
                })
            },

            checkAuth (callback) {
                if (!this.CONTENT) {
                    return
                }

                this.request(this.API.pdfCheckAuth, {
                    params: { dataid: this.$route.query.id, datatype: "book", name: this.CONTENT.name }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.auth = res.data.hasAuth;
                        let url = crypto.decrypt(res.data.url);
                        callback && callback(url);
                    }
                })
            },
            openPDF () {
                this.checkAuth((url) => {
                    if ((url || '') == '') {
                        return;
                    }
                    this.CONTENT.resourceUrl = url;
                    if ((this.data.contentPdfViewType || '') == 'NEW_WINDOW') {
                        window.open(`/web/viewer${this.data.isPdfReadOnly === 1 ? '_noop' : ''}.html?file=` + encodeURIComponent(url), '_blank');
                    }
                    else {
                        this.showViewCONTENT = true;
                    }
                });
            },
            openPreviewSub (data) {
                // 'https://ebookdev.198.daxue.cloud/' + 
                this.previewSubData.resourceUrl = data.filePath;
                this.previewSubData.originalName = data.fileName;
                this.previewSubData.show = true
            },
            loadData () {
                this.loadings = true

                if (!this.$route.query.id) {
                    return;
                }


                this.request(this.API.bookDetail, {
                    params: { id: this.$route.query.id }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.data = res.data;


                        let printPublishcation = this.data.publication.filter(item => {
                            return (item.mediumCode || '').toLowerCase() == "print";
                        })?.[0];

                        let ebookPublication = this.data.publication.filter(item => {
                            return item.mediumCode == "EBook";
                        })?.[0];

                        if (res.data.bookPublishType == 'EBook') {
                            this.publication = ebookPublication;
                        } else if (this.data.bookPublishType == 'print') {
                            this.publication = printPublishcation;
                        } else {
                            this.publication = ebookPublication;
                        }


                        this.data.bookRelatedPerson?.forEach(item => {
                            if (this.bookRelatedPersonGroup[item.relatedType]) {
                                this.bookRelatedPersonGroup[item.relatedType].push(item)
                            } else {
                                this.bookRelatedPersonGroup[item.relatedType] = [item]
                            }
                        })

                        this.TOC = (this.data.contentPdf || []).filter(item => item.relationType == 'TOC')[0];
                        this.CONTENT = (this.data.contentPdf || []).filter(item => item.relationType == 'CONTENT')[0];
                        this.PREVIEW = (this.data.contentPdf || []).filter(item => item.relationType == 'PREVIEW')[0]

                        var title = this.data.title

                        switch (this.$route.query.from) {
                            case 'book':
                                this.breadcrumb = [{ title: this.LAN.nav.book, url: 'book' }, { title }]
                                break
                            case 'bookSuccession':
                                this.breadcrumb = [{ title: this.LAN.nav.bookSuccession, url: 'bookSuccession' }, { title }]
                                break
                            case 'bookLight':
                                this.breadcrumb = [{ title: this.LAN.nav.bookLight, url: 'bookLight' }, { title }]
                                break
                            case 'bookList':
                                this.breadcrumb = [{ title: this.LAN.nav.STY, url: 'bookList' }, { title }]
                                break
                            case 'mine':
                                this.breadcrumb = [{ title: this.LAN.nav.mine, url: 'mine' }, { title }]
                                break
                            case 'order':
                                this.breadcrumb = [{ title: this.LAN.nav.mine, url: 'mine', query: { type: 'order' } }, { title }]
                                break
                            case 'cart':
                                this.breadcrumb = [{ title: this.LAN.cart.title, url: 'shoppingCart' }, { title }]
                                break
                        }

                        this.pubTableData = this.data.publication?.map(item => {
                            return {
                                publishDate: item.publishDate || '-',
                                ISBN10: item.isbn10 || '-',
                                ISBN13: item.isbn13 || '-',
                                medium: item.mediumDesc || '-',
                                binding: item.bindingDesc || '-',
                                size: item.size || '-',
                                publishStatus: item.publishStatusDesc || '-'
                            }
                        })

                        this.loadings = false;

                        this.$nextTick(() => {
                            this.parseMathJax()

                            this.mathHackBottom()
                        })

                        this.checkContentPermission();
                    }
                }).catch(err => {
                    this.loadings = false
                })

                this.loadCMSList()
            },
            loadCMSList () {
                this.loadingCMS = true;

                this.request(this.API.relativeCMSData, {
                    params: {
                        bookOrPeriodicalId: this.$route.query.id,
                        objectType: 'BOOK',
                        current: 1,
                        size: 9999,
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.CMSList = res.data.records
                    }

                    this.loadingCMS = false

                    this.$nextTick(() => {
                        this.parseMathJax()
                    })
                }).catch(err => {
                    this.loadingCMS = false
                })
            },
            mathHackBottom () {
                var details = document.querySelectorAll('#book-detail > div');

                if (details) {
                    var last = details[details.length - 1];
                    this.hackBottom = document.body.clientHeight - 150 - (last ? last.offsetHeight : 0)
                }
            },
            changeNewsDetail (id) {
                this.newsDetailId = id

                history.replaceState({}, '', 'BDetail?from=' + this.$route.query.from + '&id=' + this.$route.query.id + (this.newsDetailId ? '&newsDetailId=' + this.newsDetailId : ''))
            },
            scrollTo (type) {
                this.newsDetailId = null

                history.replaceState({}, '', 'BDetail?from=' + this.$route.query.from + '&id=' + this.$route.query.id)

                this.$nextTick(() => {
                    const target = document.getElementById(type);
                    target.scrollIntoView({ behavior: 'smooth' });
                })
            },
            goContact () {
                this.$router.push({ name: 'contact' })
            },
            gotoAmazonBookPage (link) {
                window.open(link, '_blank');
            },
            async toBuy (item) {
                try {
                    // 先检查购物车中是否已存在这本书
                    const cartItems = await indexedDBManager.getCartItems();
                    const existingItem = cartItems.find(cartItem =>
                        cartItem.id === item.id && cartItem.mediumCode === item.mediumCode
                    );

                    if (existingItem) {
                        this.$message.error(this.LAN.cart.bookAlreadyInCart);
                        return;
                    }

                    // 如果不存在，则添加到购物车
                    await indexedDBManager.addToCart({ id: this.publication.id, bid: this.$route.query.id });

                    this.$store.dispatch('cacheCartList')

                    setTimeout(() => {
                        // 跳转到购物车页面
                        this.$router.push({ name: 'shoppingCart', query: { from: 'bookDetail' } });
                    }, 300);
                } catch (error) {
                    this.$message.error(this.LAN.cart.addToCartFailed);
                }
            },
            isInCart () {
                return this.cartList.some(cartItem => cartItem.bid === this.$route.query.id && cartItem.id === this.publication.id)
            }
        }),
        components: {
            NImage,
            DocView,
            DocViewNoOp,
            Breadcrumb,
            LinkOutlined,
            NewsDetailContent,
            BookTable,
            NEditorParser,
            ArrowRightOutlined
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .list-thumb {
        width: 170px;
        height: 246px;

        .list-thumb-image {
            transition: all 0.3s;
        }
    }

    .list-item {
        transition: all 0.3s;

        &:hover {
            box-shadow: $shadow-2;
        }
    }

    .book-introduce {
        table {
            display: table;
        }

        ul {
            display: none;
        }
    }

    @media screen and (max-width: 1100px) {
        .book-introduce {
            table {
                display: none;
            }

            ul {
                display: block;
            }
        }

        .book-top {
            display: block;

            .book-info {
                margin: 15px auto;
                display: block;
                width: auto;
                padding: 0 10px;

                .list-thumb {
                    margin: 0 auto;
                }
            }
        }

        .detail-body {
            padding: 20px;
            flex-direction: column;
        }
    }

    .b-detail-title {
        font-size: 40px;
        line-height: 48px;
    }

    .book-pub-list {
        width: 260px;
        background-image: linear-gradient(to right, #d4eaf7, #b6ccd8);

        button {
            height: 30px;
            border-radius: 15px;
            border: none;
        }
    }

    .book-menu {
        width: 150px;

        li.n-active {
            color: $color-base;
        }
    }

    .buy-button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>
<style lang="scss">
    .pub-table {
        .ant-table-thead > tr > th {
            background-color: transparent;
        }
    }

    .pdf-dialog {
        max-width: 100% !important;

        .ant-modal-header {
            background: rgba(56, 56, 61, 1);
            padding: 10px;
            height: 40px;
            border-bottom: 0;
        }

        .ant-modal-title {
            color: $font-color-1;
        }

        .ant-modal-close-x {
            color: $font-color-1;
            width: 40px;
            height: 40px;
            line-height: 40px;
        }

        .ant-modal-content {
            height: 100%;
        }

        .ant-modal-body {
            height: calc(100% - 40px);
        }
    }
</style>